import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import { ModalFullscreen } from '@cian/ui-kit/modal';
import { useState } from 'react';

import { NoPhoto } from 'shared/components/common/NoPhoto';
import type { IBuildingPhoto } from 'shared/types/buildingCard';

import { GallerySlider } from './components/GallerySlider';

import style from './style.css';

export interface IBuildingGalleryProps {
  photos: IBuildingPhoto[];
  /** alt по фото — SEO-шаблоны монолита (`getPhotoAlts`) */
  alts: string[];
}

/** Галерея — как `photo_gallery.html` и fotorama монолита */
export const BuildingGallery = ({ photos, alts }: IBuildingGalleryProps) => {
  const defaultSlide = Math.max(
    photos.findIndex(photo => photo.isDefault),
    0,
  );
  const [currentSlide, setCurrentSlide] = useState(defaultSlide);
  const [isFullscreen, setIsFullscreen] = useState(false);

  if (!photos.length) {
    return (
      <div className={`${style['container']} ${style['empty']}`} data-name="GalleryEmpty">
        <NoPhoto variant="gallery" />
      </div>
    );
  }

  if (photos.length === 1) {
    return (
      <div className={`${style['container']} ${style['single']}`} data-name="GallerySingle">
        <img className={style['image']} src={photos[0].fullUrl} alt={alts[0]} />
      </div>
    );
  }

  return (
    <div className={style['container']}>
      <GallerySlider
        photos={photos}
        alts={alts}
        initialSlide={defaultSlide}
        activeSlide={currentSlide}
        onSlideChange={setCurrentSlide}
        onFullscreenClick={() => setIsFullscreen(true)}
      />
      <ModalFullscreen open={isFullscreen} escape theme="black" onClose={() => setIsFullscreen(false)}>
        <div className={style['fullscreen']} data-name="GalleryFullscreen">
          <button type="button" className={style['close']} title="Закрыть" onClick={() => setIsFullscreen(false)}>
            <IconActionClose16 color="icon-inverted-default" />
          </button>
          <GallerySlider
            photos={photos}
            alts={alts}
            initialSlide={currentSlide}
            isFullscreen
            onSlideChange={setCurrentSlide}
          />
        </div>
      </ModalFullscreen>
    </div>
  );
};
